import { useEffect } from 'react';
import { useAllFieldsBaseQuery } from 'queries/fields';
import { useAccountMetaQuery, useTaskFieldsQuery } from '..';
import { useAccountDataQuery } from '../account';
import { useMembersQuery, useMembersV2Query } from '../members';
import { useResourceManagementConfigQuery } from '../resource-management-configuration';
import { useTimesheetConfiguration } from '../timesheets/configuration';

declare global {
  interface Window {
    destroyWorker?: () => void;
  }
}

const useInitData = () => {
  const { isLoading: isMetaLoading } = useAccountMetaQuery();

  const { isLoading: isAccountsLoading } = useAccountDataQuery();

  const { isLoading: isAllFieldsLoading } = useAllFieldsBaseQuery();

  const { isLoading: isResourceManagementConfigLoading } =
    useResourceManagementConfigQuery();

  const { isLoading: isTaskFieldsLoading } = useTaskFieldsQuery();

  const { isLoading: isMembersQueryLoading } = useMembersQuery();

  const { isLoading: isMembersV2Loading } = useMembersV2Query({});

  const { isLoading: isTimeSheetConfigurationLoading } =
    useTimesheetConfiguration();

  useEffect(() => {
    const isEverythingLoaded = Boolean(
      isAccountsLoading === false &&
        isMetaLoading === false &&
        isAllFieldsLoading === false &&
        isTaskFieldsLoading === false &&
        isTimeSheetConfigurationLoading === false &&
        isResourceManagementConfigLoading === false &&
        isMembersQueryLoading === false &&
        isMembersV2Loading === false,
    );

    if (isEverythingLoaded && window.destroyWorker) {
      window.destroyWorker();
    }
  }, [
    isAccountsLoading,
    isMetaLoading,
    isAllFieldsLoading,
    isTaskFieldsLoading,
    isTimeSheetConfigurationLoading,
    isResourceManagementConfigLoading,
    isMembersQueryLoading,
    isMembersV2Loading,
  ]);

  return Boolean(isAccountsLoading && isMetaLoading && isAllFieldsLoading);
};

export { useInitData };
